import { defineComponent as u, ref as h, watch as f, openBlock as k, createElementBlock as b, normalizeClass as p, createVNode as t, unref as o, withCtx as g, createElementVNode as x } from "vue";
import v from "./ghl-ui.es439.js";
import "./ghl-ui.es440.js";
import S from "./ghl-ui.es441.js";
import C from "./ghl-ui.es259.js";
const w = ["id"], y = { class: "hl-image-checkbox__wrapper" }, B = u({
  __name: "CheckboxImage",
  props: {
    id: {
      type: String,
      required: !0
    },
    src: {
      type: String,
      default: ""
    },
    fallbackSrc: {
      type: String,
      default: ""
    },
    checked: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },
  emits: ["onSelect"],
  setup(c, { emit: i }) {
    const l = c, e = h(l.checked || !1), d = i, r = () => {
      e.value ? d("onSelect", { url: l.src }) : d("onSelect", { url: null });
    }, n = (a, s) => {
      if (l.disabled)
        return !1;
      s.stopPropagation(), e.value = a, r();
    }, m = () => {
      if (l.disabled)
        return !1;
      e.value = !e.value, r();
    };
    return f(
      () => l.checked,
      (a) => {
        e.value = a;
      }
    ), (a, s) => (k(), b("div", {
      class: p(["hl-image-checkbox", [e.value ? "image-checked" : null, c.disabled ? "disabled" : null]]),
      onClick: m,
      id: c.id
    }, [
      t(o(S), {
        "preview-disabled": "",
        width: "112",
        src: c.src,
        "fallback-src": c.fallbackSrc
      }, {
        placeholder: g(() => [
          t(o(v), { class: "fallback-icon" })
        ]),
        _: 1
      }, 8, ["src", "fallback-src"]),
      x("div", y, [
        t(o(C), {
          size: "small",
          checked: e.value,
          disabled: c.disabled,
          "onUpdate:checked": n
        }, null, 8, ["checked", "disabled"])
      ])
    ], 10, w));
  }
}), V = B;
export {
  V as default
};
